import React from "react"
import { Header } from "../../components/header"

export class ErrorPage extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div
                    className="rounded"
                    style={{
                        padding: "3rem 1rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        backgroundColor: "#f3c2c2",
                        maxWidth: "600px",
                        margin: "0 auto",
                    }}
                >
                    <h4>Fehler</h4>
                    <p>Es konnten keine Daten abgefragt werden.</p>
                    <p>
                        <strong>Bitte wende Dich an einen Administrator.</strong>
                    </p>
                </div>
            </>
        )
    }
}
